import * as fromActions from '../actions/acompanante.action';
import { AcompananteData } from '../models/store.model';

export const acompananteInitialState: AcompananteData | null = null;

export function acompananteDataReducer(
    state = acompananteInitialState,
    action: fromActions.AcompananteDataActions
): AcompananteData | null {
    switch (action.type) {
        case fromActions.SETACOMPANANTEDATA:
            return { ...action.acompanante };

        case fromActions.UNSETACOMPANANTEDATA:
            return null;

        default:
            return state;
    }
}
